import { OhsFilterList } from 'dashboard/topFilter/OhsFilterModels';
import { ApiResListsType } from 'global-services/api/OhsApiModels';
import { GlobalSearchState } from 'search/OhsSearchModels';
import { OhsUser } from 'user/OhsUser';
import { ModuleType } from 'global-services/constants/OhsObject';
import { OhsHrLookup } from 'human-resource/models/OhsHumanResourceModels';

export interface OhsIncidentCustomFilters {
  workplaceOwned?: boolean;
  archived?: boolean;
  categories?: string[];
  workplaces?: string[];
  next?: string;
}

export interface OhsIncidentFilterPayload extends OhsIncidentCustomFilters {
  viewPreset?: 'view_1' | 'view_2' | 'view_3';
  page: number;
  sort: {
    order: number;
    key: string;
  };
  count: boolean;
}
export interface OhsModuleListsTypes {
  rowData: any[];
  isLoading: boolean;
  totalPages: number;
}
export interface OhsIncidentRootState {
  globalfilter: {
    filterInfo: OhsFilterList;
  };
  incident: IncidentListsRecordState;
  globalSearch: GlobalSearchState;
}

export enum OhsIncidentViewPresets {
  View1IncidentList = 'view_1',
  View2IncidentList = 'view_2',
  View3IncidentList = 'view_3',
}

export interface IncidentListsRecordState {
  isLoading: boolean;
  incidentLists: ApiResListsType<any[]> | null;
  currentPage: number;
  currentViewPreset: OhsIncidentViewPresets;
}
export interface FilterOptionsProps {
  filterInfo: OhsFilterList;
  data: ApiResListsType<any[]> | null;
  currentPage: number;
}

export type Severity = 'Low' | 'Medium' | 'High' | null;

export interface BodyPart {
  bodyPart: string;
  bodyPartOther: string | null;
  injury: string;
  injuryOther: string | null;
  comment: string;
}

export interface ExternalBodiesNotified {
  name: string;
  nameOther: string;
  date: string;
  comment: string;
}

export interface EditLogs {
  by: OhsUser;
  comment: string;
  date: string;
}

export enum IncidentStatus {
  Active = 'active', // save or sign off
  Completed = 'completed', // update sign off
  Invalid = 'invalid', // invalid
}

export interface OhsIncidentSearchMain {
  searchKey: string;
  substringSearch: boolean;
  highlight: boolean;
  filter: {
    page: number;
    next?: string;
    dateDue?: {
      start: string;
      end: string;
    };
    dateOccurred?: {
      start: string;
      end: string;
    };
    skipOrgRecords: boolean;
    complete: boolean;
    archived: boolean;
    injuredPersonLinks?: string[];
    category?: string[];
    severity?: string[];
    workplaces: string[];
  };
  sort: {
    key: string;
    order: number;
  };
}

export interface LinkedIncidentType {
  _id: string;
  reference: string;
  type: ModuleType.Incident;
}

export interface InjuredPersonLinkItem extends OhsHrLookup {
  enableNotification?: boolean;
  enableManagerNotification?: boolean;
}

export interface CusvalDefinition {
  _id: string;
  type: string;
}

export interface InvestigationMethod {
  title: string;
  cusvals: CusvalDefinition;
  cusvalsDefinition: CusvalDefinition;
}

export interface TaskSignoffFlexibleFieldsConfig {
  label: string;
  field: string;
  enabled: boolean;
  required: boolean;
  investigationMethods: InvestigationMethod[];
}

export interface TaskSignoffFlexibleFields {
  value: boolean;
  investigationMethod: string;
  cusvals: {
    _id: string;
    type: string;
  };
  cusvalValues: any[] | null;
}
